var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgP4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.814,
    height: 88.813,
    viewBox: "0 0 88.814 88.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 88.814,
    height: 88.813,
    fill: "#212968"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M124.957,165.433h35.82a4.664,4.664,0,0,0,4.658-4.658v-35.82a4.663,4.663,0,0,0-4.658-4.658h-35.82a4.663,4.663,0,0,0-4.658,4.658v35.82a4.664,4.664,0,0,0,4.658,4.658m-1.5-40.479a1.5,1.5,0,0,1,1.5-1.5h35.82a1.5,1.5,0,0,1,1.5,1.5v35.82a1.5,1.5,0,0,1-1.5,1.5h-35.82a1.5,1.5,0,0,1-1.5-1.5Z",
    transform: "translate(-98.46 -98.459)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M272.2,282.628h5.415a4.715,4.715,0,0,0,4.71-4.709V272.68a1.58,1.58,0,0,0-3.161,0v5.238a1.55,1.55,0,0,1-1.549,1.549H272.2a1.58,1.58,0,1,0,0,3.161",
    transform: "translate(-221.49 -221.885)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M155.727,166.156a1.582,1.582,0,0,0,1.58-1.58v-5.237a1.55,1.55,0,0,1,1.548-1.549h5.415a1.58,1.58,0,1,0,0-3.161h-5.415a4.714,4.714,0,0,0-4.709,4.709v5.237a1.582,1.582,0,0,0,1.58,1.58",
    transform: "translate(-126.164 -126.558)",
    fill: "#212968"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M87.234,32.771a1.58,1.58,0,0,0,0-3.161H76.92V23.962H87.234a1.58,1.58,0,0,0,0-3.161H76.92v-.062a8.856,8.856,0,0,0-8.846-8.846h-.062V1.579a1.58,1.58,0,1,0-3.161,0V11.892H59.2V1.579a1.58,1.58,0,1,0-3.161,0V11.892H50.393V1.579a1.58,1.58,0,1,0-3.161,0V11.892H41.583V1.579a1.58,1.58,0,1,0-3.161,0V11.892H32.773V1.579a1.58,1.58,0,1,0-3.161,0V11.892h-5.65V1.579a1.58,1.58,0,1,0-3.161,0V11.892H20.74a8.856,8.856,0,0,0-8.846,8.846V20.8H1.58a1.58,1.58,0,0,0,0,3.161H11.894v5.649H1.58a1.58,1.58,0,1,0,0,3.161H11.894V38.42H1.58a1.58,1.58,0,0,0,0,3.161H11.894V47.23H1.58a1.58,1.58,0,0,0,0,3.161H11.894v5.65H1.58a1.58,1.58,0,0,0,0,3.161H11.894V64.85H1.58a1.58,1.58,0,0,0,0,3.161H11.894v.062a8.856,8.856,0,0,0,8.846,8.846H20.8V87.232a1.58,1.58,0,1,0,3.161,0V76.919h5.65V87.232a1.58,1.58,0,0,0,3.161,0V76.919h5.649V87.232a1.58,1.58,0,1,0,3.161,0V76.919h5.649V87.232a1.58,1.58,0,0,0,3.161,0V76.919h5.649V87.232a1.58,1.58,0,0,0,3.161,0V76.919h5.649V87.232a1.58,1.58,0,0,0,3.161,0V76.919h.062a8.856,8.856,0,0,0,8.846-8.846v-.062H87.234a1.58,1.58,0,0,0,0-3.161H76.92V59.2H87.234a1.58,1.58,0,0,0,0-3.161H76.92v-5.65H87.234a1.58,1.58,0,0,0,0-3.161H76.92V41.581H87.234a1.58,1.58,0,0,0,0-3.161H76.92V32.771ZM15.055,20.738a5.692,5.692,0,0,1,5.685-5.686H68.074a5.692,5.692,0,0,1,5.686,5.686V68.072a5.692,5.692,0,0,1-5.686,5.686H20.74a5.692,5.692,0,0,1-5.685-5.686Z",
    transform: "translate(0 0.001)",
    fill: "#212968"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4);
export default __webpack_public_path__ + "static/media/p-4.ec7c2195515b9c024d0e0bba93aeb7ee.svg";
export { ForwardRef as ReactComponent };